module.exports = __webpack_public_path__ + "img/bunge.0a8bb6df.jpg";